
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire37b7"];
var parcelRegister = parcelRequire.register;
parcelRegister("b8EMT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $31fc0b63559b10c1$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $8KhCJ = parcelRequire("8KhCJ");

var $leG06 = parcelRequire("leG06");

var $k8MAo = parcelRequire("k8MAo");

var $7Clnv = parcelRequire("7Clnv");

var $gKURT = parcelRequire("gKURT");

var $gs2u7 = parcelRequire("gs2u7");

var $9b70D = parcelRequire("9b70D");

var $2aGBJ = parcelRequire("2aGBJ");

var $4rBM8 = parcelRequire("4rBM8");

var $gx7I6 = parcelRequire("gx7I6");

var $4tmE5 = parcelRequire("4tmE5");

var $k3QGO = parcelRequire("k3QGO");

var $68WXR = parcelRequire("68WXR");

var $1UkGo = parcelRequire("1UkGo");

var $NAfW5 = parcelRequire("NAfW5");

var $4Nxm2 = parcelRequire("4Nxm2");

var $6xwQE = parcelRequire("6xwQE");

var $h6Rwg = parcelRequire("h6Rwg");

var $6KORI = parcelRequire("6KORI");
const $31fc0b63559b10c1$var$LoginPage = ()=>{
    const { state: state } = (0, $4rBM8.useLoginState)();
    const { oidcContext: oidcContext } = state || {};
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const { isPasswordlessAllowed: isPasswordlessAllowed, checkUsername: checkUsername, isUsernameChecked: isUsernameChecked, checkUsernameError: checkUsernameError, error: loginError, redirectType: redirectType, isRestrictedEmail: isRestrictedEmail, isCheckUsernameLoading: isCheckUsernameLoading, resetLogin: resetLogin, infoCode: infoCode, recaptcha: recaptcha } = (0, $4Nxm2.useLogin)();
    const { isLoading: isLoading, onLogin: handleLogIn, onPasswordlessLogin: handlePasswordlessLogIn } = (0, $6xwQE.useLoginSubmission)();
    const { onAppleLogin: onAppleLogin, onSlackLogin: onSlackLogin, onMicrosoftLogin: onMicrosoftLogin, onGoogleSocialLogin: onGoogleSocialLogin, onDismissGoogleOneTap: onDismissGoogleOneTap, socialLoginEligibility: socialLoginEligibility, envSupportsSocialLogin: envSupportsSocialLogin, isSocialBlocked: isSocialBlocked } = (0, $h6Rwg.useSocialLogin)();
    const cobrandingApplication = (0, $NAfW5.useCobrandingApplication)();
    const { isMobileApp: isMobileApp, isEmbedded: isEmbedded, screenSize: screenSize } = (0, $2aGBJ.useAppSelector)((state)=>state.microbranding);
    const isLoginSecondStep = isUsernameChecked;
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const emailFromSearchParams = (0, $NAfW5.useEmailFromSearchParams)();
    const [email, setEmail] = (0, $91i6m.useState)(()=>emailFromSearchParams || "");
    (0, $6KORI.useGoogleOneTap)({
        email: email
    });
    const { highlightedSocialProvider: highlightedSocialProvider = null, isEligibleForSocialLoginOnly: isEligibleForSocialLoginOnly = null } = socialLoginEligibility || {};
    const showSocialLoginOnly = isLoginSecondStep && isEligibleForSocialLoginOnly && highlightedSocialProvider && envSupportsSocialLogin;
    const handleGoogleSocialLogin = (0, $91i6m.useCallback)(()=>{
        if (envSupportsSocialLogin) onGoogleSocialLogin(email);
    }, [
        email,
        onGoogleSocialLogin,
        envSupportsSocialLogin
    ]);
    const handleMicrosoftLogin = (0, $91i6m.useCallback)(()=>{
        if (envSupportsSocialLogin) onMicrosoftLogin(email);
    }, [
        email,
        onMicrosoftLogin,
        envSupportsSocialLogin
    ]);
    const handleAppleLogin = (0, $91i6m.useCallback)(()=>{
        if (envSupportsSocialLogin) onAppleLogin(email);
    }, [
        email,
        onAppleLogin,
        envSupportsSocialLogin
    ]);
    const handleSlackLogin = (0, $91i6m.useCallback)(()=>{
        if (envSupportsSocialLogin) onSlackLogin(email);
    }, [
        email,
        onSlackLogin,
        envSupportsSocialLogin
    ]);
    const handleValidationError = (0, $91i6m.useCallback)((errors)=>dispatch((0, $k8MAo.showFormErrors)(errors)), [
        dispatch
    ]);
    const handleContinue = (email)=>{
        checkUsername(email);
    };
    const handleFormClick = (0, $91i6m.useCallback)(()=>{
        if (envSupportsSocialLogin && screenSize === "mobile") onDismissGoogleOneTap();
    }, [
        onDismissGoogleOneTap,
        screenSize,
        envSupportsSocialLogin
    ]);
    const handleEmailChange = (0, $91i6m.useCallback)((email)=>{
        setEmail(email);
    }, []);
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8KhCJ.default), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)("title", {
                    children: formatMessage((0, $9b70D.LoginPageMessages).headTitle)
                })
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gs2u7.default), {
                pageId: (0, $1UkGo.pageId),
                header: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4tmE5.default), {
                    highlightedSocialProvider: highlightedSocialProvider,
                    showSocialLoginOnly: showSocialLoginOnly
                }),
                footer: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gx7I6.default), {
                    oidcContext: oidcContext,
                    isEmbedded: isEmbedded
                }),
                whiteboxFooter: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $68WXR.default), {
                    showSocialLoginOnly: showSocialLoginOnly,
                    isMobileApp: isMobileApp,
                    oidcContext: oidcContext
                }),
                children: showSocialLoginOnly ? /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gKURT.default), {
                    email: email,
                    highlightedSocialProvider: highlightedSocialProvider,
                    handleGoogleLogin: handleGoogleSocialLogin,
                    handleMicrosoftLogin: handleMicrosoftLogin,
                    handleAppleLogin: handleAppleLogin,
                    handleSlackLogin: handleSlackLogin
                }) : /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $7Clnv.default), {
                            application: cobrandingApplication || null,
                            redirectType: !isLoginSecondStep ? redirectType : null,
                            isRedirecting: redirectType !== null,
                            isSecondStep: isLoginSecondStep,
                            isPasswordlessAllowed: isPasswordlessAllowed,
                            isLoading: isLoading,
                            isCheckUsernameLoading: isCheckUsernameLoading,
                            onContinue: handleContinue,
                            onLogIn: handleLogIn,
                            onPasswordlessLogIn: handlePasswordlessLogIn,
                            error: loginError,
                            info: infoCode,
                            fieldErrors: {
                                email: checkUsernameError
                            },
                            email: email,
                            onValidationError: handleValidationError,
                            onEditEmail: resetLogin,
                            onFormClick: handleFormClick,
                            restrictedEmail: isRestrictedEmail,
                            pageId: (0, $1UkGo.pageId),
                            onEmailChange: handleEmailChange,
                            recaptchaEnabled: recaptcha.enabled,
                            recaptchaComponent: recaptcha.component
                        }),
                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $k3QGO.default), {
                            isEmbedded: isEmbedded,
                            envSupportsSocialLogin: envSupportsSocialLogin,
                            isSocialBlocked: isSocialBlocked,
                            onSlackLogin: handleSlackLogin,
                            onAppleLogin: handleAppleLogin,
                            onMicrosoftLogin: handleMicrosoftLogin,
                            onGoogleLogin: handleGoogleSocialLogin
                        })
                    ]
                })
            })
        ]
    });
};
var $31fc0b63559b10c1$export$2e2bcd8739ae039 = $31fc0b63559b10c1$var$LoginPage;

});
parcelRegister("7Clnv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2307c23eea04d7f$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $9OWP7 = parcelRequire("9OWP7");

var $fqDmW = parcelRequire("fqDmW");

var $bt1Sd = parcelRequire("bt1Sd");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");

var $gFwNN = parcelRequire("gFwNN");

var $dmC2D = parcelRequire("dmC2D");

var $9w0eB = parcelRequire("9w0eB");

var $lkawQ = parcelRequire("lkawQ");

var $cLysE = parcelRequire("cLysE");

var $31nHY = parcelRequire("31nHY");

var $lnbpL = parcelRequire("lnbpL");

var $j7UeI = parcelRequire("j7UeI");

var $jthWj = parcelRequire("jthWj");

var $gtKO2 = parcelRequire("gtKO2");

var $fYxRW = parcelRequire("fYxRW");

var $1V2cH = parcelRequire("1V2cH");

var $1UkGo = parcelRequire("1UkGo");

var $cZAbO = parcelRequire("cZAbO");

var $6eNI5 = parcelRequire("6eNI5");

var $cs6gC = parcelRequire("cs6gC");
let $a2307c23eea04d7f$var$_ = (t)=>t, $a2307c23eea04d7f$var$t, $a2307c23eea04d7f$var$t1, $a2307c23eea04d7f$var$t2;
const $a2307c23eea04d7f$export$d55ce944e082b58f = (0, $fqDmW.default).div($a2307c23eea04d7f$var$t || ($a2307c23eea04d7f$var$t = $a2307c23eea04d7f$var$_`
  align-items: center;
  color: ${0};
  display: flex;
  height: 40px;
  justify-content: space-between;
  padding: 0 8px;
`), (0, $kLNLK).N90);
const $a2307c23eea04d7f$export$a7fed597f4b8afd8 = (0, $fqDmW.default).form($a2307c23eea04d7f$var$t1 || ($a2307c23eea04d7f$var$t1 = $a2307c23eea04d7f$var$_`
  margin: 0;
`));
const $a2307c23eea04d7f$var$InputsWrapper = (0, $fqDmW.default).div($a2307c23eea04d7f$var$t2 || ($a2307c23eea04d7f$var$t2 = $a2307c23eea04d7f$var$_`
  margin-bottom: ${0}px;
`), (0, $6e88g.gridSize)());
const $a2307c23eea04d7f$export$1f58f750f20f344b = ({ application: application, email: email, error: error, fieldErrors: fieldErrors, info: info, isLoading: isLoading, isPasswordlessAllowed: isPasswordlessAllowed, isRedirecting: isRedirecting, isSecondStep: isSecondStep, isCheckUsernameLoading: isCheckUsernameLoading, onContinue: onContinue, onEditEmail: onEditEmail, onEmailChange: onEmailChange, onFormClick: onFormClick, onLogIn: onLogIn, onPasswordlessLogIn: onPasswordlessLogIn, onValidationError: onValidationError, pageId: pageId, redirectType: redirectType, restrictedEmail: restrictedEmail, recaptchaEnabled: recaptchaEnabled, recaptchaComponent: recaptchaComponent })=>{
    const intl = (0, $leG06.default)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const [password, setPassword] = (0, $91i6m.useState)("");
    const [buttonClicked, setButtonClicked] = (0, $91i6m.useState)("submit");
    const inputRef = (0, $91i6m.useRef)(null);
    const [passwordFieldError, setPasswordFieldError] = (0, $91i6m.useState)(null);
    const onEmailClick = (0, $91i6m.useCallback)(()=>{
        setPassword("");
        setPasswordFieldError(null);
        onEditEmail();
    }, [
        onEditEmail
    ]);
    const { captchaValue: captchaValue, isRequired: isTooManyAttemptsRecaptchaRequired } = (0, $6eNI5.useLoginTooManyAttemptsRecaptchaContext)();
    const handleSubmit = async (e)=>{
        const trimmedEmail = email.trim();
        const emailEmpty = trimmedEmail === "";
        const passwordEmpty = password === "";
        e.preventDefault();
        if (isLoading) return;
        if (emailEmpty) {
            var _inputRef_current;
            (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
            const emailValidationError = formatMessage((0, $jthWj.default).emailEmpty);
            analyticsClient.errorShownEvent((0, $1UkGo.pageId), "validationError");
            onValidationError({
                email: emailValidationError
            });
        }
        setButtonClicked("submit");
        if (!isSecondStep) {
            analyticsClient.buttonClickedEvent(pageId, "continueToLogin");
            if (!emailEmpty) onContinue(trimmedEmail);
        } else {
            analyticsClient.buttonClickedEvent(pageId, "login");
            if (passwordEmpty) setPasswordFieldError(formatMessage((0, $jthWj.default).passwordEmpty));
            else if (!emailEmpty) onLogIn(trimmedEmail, password);
        }
    };
    const handlePasswordlessButtonClick = async ()=>{
        const trimmedEmail = email.trim();
        if (isLoading || !trimmedEmail) return;
        setButtonClicked("passwordless");
        onPasswordlessLogIn(trimmedEmail);
    };
    const handlePasswordChange = (0, $91i6m.useCallback)((e)=>{
        if (passwordFieldError) setPasswordFieldError(null);
        setPassword(e.currentTarget.value);
    }, [
        passwordFieldError,
        setPasswordFieldError,
        setPassword
    ]);
    const buttonContent = ()=>{
        if (!isSecondStep) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "login.form.continue",
            defaultMessage: "Continue"
        });
        if (isPasswordlessAllowed) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "common.login.with.password",
            defaultMessage: "Log in with password"
        });
        return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "common.login",
            defaultMessage: "Log in"
        });
    };
    const infoContent = ()=>{
        const { formatMessage: formatMessage } = intl;
        const applicationName = application ? (0, $fYxRW.applications)[application].name : "Product";
        const testId = "login-info-test-id";
        if (info) switch(info.code){
            case "migratingExistingUser":
                {
                    const summary = formatMessage((0, $jthWj.default).migrateAccountInfo, {
                        application: applicationName
                    });
                    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lnbpL.default), {
                        id: "login-info",
                        "data-testid": testId,
                        children: summary
                    });
                }
            case "existingUserSignupAttempt":
                {
                    const summary = formatMessage((0, $jthWj.default).existingUserSignupAttemptInfo);
                    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lnbpL.default), {
                        id: "login-info",
                        "data-testid": testId,
                        children: summary
                    });
                }
            default:
                return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lnbpL.default), {
                    id: "login-info",
                    "data-testid": testId,
                    isHidden: true,
                    children: " "
                });
        }
    };
    (0, $91i6m.useEffect)(()=>{
        analyticsClient.stopInitialLoadApdexEvent("viewLoginPage");
    }, [
        analyticsClient
    ]);
    const emailError = ()=>{
        const error = fieldErrors.email;
        switch(error){
            case "unknown":
                return intl.formatMessage((0, $jthWj.default).unexpectedErrorHappened);
            case "rate_limit_exceeded_message":
                return intl.formatMessage((0, $jthWj.default).rateLimitErrorMessage);
            default:
                return error;
        }
    };
    const renderExperimentButtons = ()=>{
        if (redirectType === (0, $gtKO2.CheckUserNameRedirectType).Sso) return /*#__PURE__*/ (0, $4ZSso.jsxs)($a2307c23eea04d7f$export$d55ce944e082b58f, {
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "login.form.opening.sso",
                    defaultMessage: "Opening your single sign-on provider"
                }),
                /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9OWP7.default), {})
            ]
        });
        else return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
            appearance: "primary",
            id: "login-submit",
            type: "submit",
            isFullWidth: true,
            isDisabled: isSecondStep && isTooManyAttemptsRecaptchaRequired && !captchaValue,
            isLoading: buttonClicked === "submit" && (!!isRedirecting || isLoading || isCheckUsernameLoading),
            children: buttonContent()
        });
    };
    const { formatMessage: formatMessage } = intl;
    return /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
        children: [
            error && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $31nHY.default), {
                children: error === null || error === void 0 ? void 0 : error.message
            }),
            /*#__PURE__*/ (0, $4ZSso.jsxs)("span", {
                children: [
                    " ",
                    infoContent(),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $4ZSso.jsxs)($a2307c23eea04d7f$export$a7fed597f4b8afd8, {
                id: "form-login",
                "data-testid": "form-login",
                onSubmit: handleSubmit,
                onClick: onFormClick,
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsxs)($a2307c23eea04d7f$var$InputsWrapper, {
                        children: [
                            restrictedEmail || redirectType === (0, $gtKO2.CheckUserNameRedirectType).Sso ? /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lkawQ.default), {
                                value: email
                            }) : /*#__PURE__*/ (0, $4ZSso.jsx)((0, $dmC2D.default), {
                                isReadOnly: isSecondStep || isLoading,
                                fieldError: emailError(),
                                onChange: onEmailChange,
                                value: email,
                                onEmailClick: onEmailClick,
                                placeholderOverride: formatMessage((0, $jthWj.default).emailPlaceholder),
                                inputRef: inputRef
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9w0eB.default), {
                                isHidden: !isSecondStep,
                                fieldError: passwordFieldError || undefined,
                                onChange: handlePasswordChange,
                                value: password,
                                className: `field-group password-field ${isSecondStep ? "expanded" : "hidden"}`
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cZAbO.LoginRecaptcha), {
                                recaptchaEnabled: recaptchaEnabled,
                                recaptchaComponent: recaptchaComponent
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cs6gC.LoginMarketingConsent), {})
                        ]
                    }),
                    renderExperimentButtons(),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gFwNN.default), {
                        isHidden: !isSecondStep || !isPasswordlessAllowed,
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $j7UeI.StyledSocialLoginButton), {
                            id: "passwordless-button",
                            iconBefore: /*#__PURE__*/ (0, $4ZSso.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bt1Sd))), {
                                label: "email"
                            }),
                            iconAfter: /*#__PURE__*/ (0, $4ZSso.jsx)("span", {
                                style: {
                                    width: 24
                                }
                            }),
                            isFullWidth: true,
                            advisoryEnabled: false,
                            onClick: handlePasswordlessButtonClick,
                            isLoading: buttonClicked === "passwordless" && (!!isRedirecting || isLoading),
                            isDisabled: isTooManyAttemptsRecaptchaRequired && !captchaValue || isLoading || isRedirecting,
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                id: "login.form.passwordless.button",
                                defaultMessage: "Log in with email"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $a2307c23eea04d7f$export$2e2bcd8739ae039 = $a2307c23eea04d7f$export$1f58f750f20f344b;

});
parcelRegister("bt1Sd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8593db29877e5ae9$var$_react = $8593db29877e5ae9$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6crSb = parcelRequire("6crSb");
function $8593db29877e5ae9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $8593db29877e5ae9$var$EmailIcon = (props)=>/*#__PURE__*/ $8593db29877e5ae9$var$_react.default.createElement($6crSb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M5 7v10h14V7H5zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h14z" fill-rule="nonzero"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 004.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.119 1.119 0 01-1.583 0L5.498 6.5z"/></g></svg>`
    }, props));
$8593db29877e5ae9$var$EmailIcon.displayName = "EmailIcon";
var $8593db29877e5ae9$var$_default = $8593db29877e5ae9$var$EmailIcon;
module.exports.default = $8593db29877e5ae9$var$_default;

});

parcelRegister("gFwNN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1439af55d1343b8c$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $fqDmW = parcelRequire("fqDmW");

var $6e88g = parcelRequire("6e88g");
let $1439af55d1343b8c$var$_ = (t)=>t, $1439af55d1343b8c$var$t;
const $1439af55d1343b8c$var$FieldGroupStyled = (0, $fqDmW.default).div($1439af55d1343b8c$var$t || ($1439af55d1343b8c$var$t = $1439af55d1343b8c$var$_`
  margin-top: ${0}px;
  transform-origin: 50% 0;
  transition-property: visibility, height, margin-top, opacity, transform;
  transition-duration: 0s, 0.2s, 0.2s, 0.2s;
  transition-timing-function: ease-in-out;

  /* Offset @atlaskit/form/Field margin-top */
  &:first-of-type {
    margin-top: ${0}px;
  }

  &.hidden {
    height: 0;
    margin-top: 0;
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
    overflow: hidden;
  }
`), (0, $6e88g.gridSize)(), -(0, $6e88g.gridSize)());
function $1439af55d1343b8c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $4ZSso.jsx)($1439af55d1343b8c$var$FieldGroupStyled, {
        ...props,
        className: `${props.className ? props.className : ""} ${props.isHidden ? "hidden" : ""}`
    });
}

});

parcelRegister("dmC2D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a37bcfc7af5918f1$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $fqDmW = parcelRequire("fqDmW");

var $aiPk3 = parcelRequire("aiPk3");

var $h89s9 = parcelRequire("h89s9");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");

var $gFwNN = parcelRequire("gFwNN");

var $8tnYQ = parcelRequire("8tnYQ");

var $26Riy = parcelRequire("26Riy");

var $gaHKK = parcelRequire("gaHKK");

var $leG06 = parcelRequire("leG06");

var $0wXBc = parcelRequire("0wXBc");
let $a37bcfc7af5918f1$var$_ = (t)=>t, $a37bcfc7af5918f1$var$t, $a37bcfc7af5918f1$var$t1, $a37bcfc7af5918f1$var$t2, $a37bcfc7af5918f1$var$t3;
// Offset FieldGroup negative margin by adding a top margin here.
const $a37bcfc7af5918f1$var$ReadOnlyEmail = (0, $fqDmW.default).div($a37bcfc7af5918f1$var$t1 || ($a37bcfc7af5918f1$var$t1 = $a37bcfc7af5918f1$var$_`
  margin-top: ${0}px;
  border: 1px solid rgba(255, 255, 255, 0);
  border-radius: 5px;
  box-sizing: border-box;
  cursor: pointer;
  height: 39px;
  outline: none;
  padding: 9px 32px 9px 8px;
  transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;

  &:hover {
    background: ${0};
    border-color: ${0};
  }
  &:focus {
    border-color: ${0};
    border-width: 2px;
    padding: 8px 31px 8px 7px;
  }

  ${0}
`), (0, $6e88g.gridSize)(), (0, $kLNLK).N10, (0, $kLNLK).N20, (0, $kLNLK).B100, (0, $26Riy.media).handheld($a37bcfc7af5918f1$var$t || ($a37bcfc7af5918f1$var$t = $a37bcfc7af5918f1$var$_`
    font-size: 16px;
  `)));
const $a37bcfc7af5918f1$var$ReadOnlyEmailText = (0, $fqDmW.default).span($a37bcfc7af5918f1$var$t2 || ($a37bcfc7af5918f1$var$t2 = $a37bcfc7af5918f1$var$_`
  display: flex;
  overflow: hidden;
  white-space: nowrap;
`));
const $a37bcfc7af5918f1$var$StyledFieldIconContainer = (0, $fqDmW.default)((0, $8tnYQ.default))($a37bcfc7af5918f1$var$t3 || ($a37bcfc7af5918f1$var$t3 = $a37bcfc7af5918f1$var$_`
  float: right;
  margin-top: -22px;
  margin-right: -27px;
`));
const $a37bcfc7af5918f1$var$EmailContainer = ({ fieldError: fieldError, isReadOnly: isReadOnly, onChange: onChange, onEmailClick: onEmailClick, placeholderOverride: placeholderOverride, value: value, inputRef: inputRef })=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const prevIsReadOnly = (0, $0wXBc.usePrevious)(isReadOnly);
    (0, $91i6m.useEffect)(()=>{
        var _inputRef_current;
        if (!isReadOnly && prevIsReadOnly) (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
    }, [
        isReadOnly,
        prevIsReadOnly,
        inputRef
    ]);
    const handleChange = (e)=>{
        const newValue = e.currentTarget.value;
        onChange(newValue);
    };
    const handleReadOnlyKeyDown = (e)=>{
        if (e.key === "Enter") {
            e.preventDefault();
            onEmailClick();
        }
    };
    const placeholder = placeholderOverride || formatMessage((0, $gaHKK.default).loginFormUsernamePlaceholder);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gFwNN.default), {
        children: isReadOnly ? /*#__PURE__*/ (0, $4ZSso.jsxs)($a37bcfc7af5918f1$var$ReadOnlyEmail, {
            onClick: onEmailClick,
            tabIndex: 0,
            onKeyDown: handleReadOnlyKeyDown,
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsx)($a37bcfc7af5918f1$var$ReadOnlyEmailText, {
                    children: value
                }),
                /*#__PURE__*/ (0, $4ZSso.jsx)($a37bcfc7af5918f1$var$StyledFieldIconContainer, {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aiPk3))), {
                        label: ""
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $4ZSso.jsx)((0, $h89s9.default), {
            id: "username",
            testId: "username" // used in pollinators
            ,
            name: "username",
            autoComplete: "username",
            type: "email",
            placeholder: placeholder,
            label: formatMessage((0, $gaHKK.default).loginFormUsernameLabel),
            autoFocus: !isReadOnly,
            isLabelHidden: true,
            onChange: handleChange,
            isInvalid: !!fieldError,
            invalidMessage: fieldError,
            value: value,
            ref: inputRef
        })
    });
};
var $a37bcfc7af5918f1$export$2e2bcd8739ae039 = $a37bcfc7af5918f1$var$EmailContainer;

});
parcelRegister("aiPk3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7803655e4c5390ba$var$_react = $7803655e4c5390ba$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6crSb = parcelRequire("6crSb");
function $7803655e4c5390ba$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7803655e4c5390ba$var$EditFilledIcon = (props)=>/*#__PURE__*/ $7803655e4c5390ba$var$_react.default.createElement($6crSb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M4.02 19.23a1 1 0 001.18 1.18l3.81-.78-4.21-4.21-.78 3.81zM19.844 6.707l-2.12-2.122A1.997 1.997 0 0016.308 4c-.512 0-1.024.195-1.415.585l-9.757 9.758 4.95 4.95 9.757-9.758a2 2 0 000-2.828z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$7803655e4c5390ba$var$EditFilledIcon.displayName = "EditFilledIcon";
var $7803655e4c5390ba$var$_default = $7803655e4c5390ba$var$EditFilledIcon;
module.exports.default = $7803655e4c5390ba$var$_default;

});

parcelRegister("h89s9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $666bf2328d96f7b9$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $7ecAu = parcelRequire("7ecAu");

var $9yEtj = parcelRequire("9yEtj");
var $iO71n = parcelRequire("iO71n");
const $666bf2328d96f7b9$var$FormTextField = ({ name: name, label: label, isLabelHidden: isLabelHidden, invalidMessage: invalidMessage, testId: testId, isRequired: isRequired, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $iO71n.default), {
        name: name,
        label: !isLabelHidden && label,
        isRequired: isRequired,
        "aria-required": isRequired,
        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $4ZSso.jsxs)((0, $91i6m.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $7ecAu.default), {
                        ...fieldProps,
                        ...props,
                        testId: testId,
                        ref: ref
                    }),
                    invalidMessage && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9yEtj.ErrorMessage), {
                        children: invalidMessage
                    })
                ]
            })
    });
};
var $666bf2328d96f7b9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).forwardRef($666bf2328d96f7b9$var$FormTextField);

});
parcelRegister("7ecAu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54339ad51eb86f63$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $61RDg = parcelRequire("61RDg");

var $dsN6L = parcelRequire("dsN6L");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $lPOF7 = parcelRequire("lPOF7");

var $koa2c = parcelRequire("koa2c");

var $4ucu0 = parcelRequire("4ucu0");
var $54339ad51eb86f63$var$_excluded = [
    "appearance",
    "className",
    "elemAfterInput",
    "elemBeforeInput",
    "isCompact",
    "isDisabled",
    "isInvalid",
    "isMonospaced",
    "isReadOnly",
    "isRequired",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onMouseDown",
    "placeholder",
    "testId",
    "width"
];
function $54339ad51eb86f63$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $54339ad51eb86f63$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $54339ad51eb86f63$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $54339ad51eb86f63$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $54339ad51eb86f63$var$analyticsParams = {
    componentName: "textField",
    packageName: "@atlaskit/textfield",
    packageVersion: "6.4.2"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ var $54339ad51eb86f63$var$Textfield = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(props, ref) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "standard" : _props$appearance, className = props.className, elemAfterInput = props.elemAfterInput, elemBeforeInput = props.elemBeforeInput, _props$isCompact = props.isCompact, isCompact = _props$isCompact === void 0 ? false : _props$isCompact, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isMonospaced = props.isMonospaced, isMonospaced = _props$isMonospaced === void 0 ? false : _props$isMonospaced, _props$isReadOnly = props.isReadOnly, isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly, _props$isRequired = props.isRequired, isRequired = _props$isRequired === void 0 ? false : _props$isRequired, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, onMouseDown = props.onMouseDown, placeholder = props.placeholder, testId = props.testId, width = props.width, spreadProps = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(props, $54339ad51eb86f63$var$_excluded);
    var inputRef = (0, $91i6m.useRef)(null);
    var handleOnFocus = (0, $koa2c.usePlatformLeafEventHandler)($54339ad51eb86f63$var$_objectSpread({
        fn: function fn(event) {
            onFocus && onFocus(event);
        },
        action: "focused"
    }, $54339ad51eb86f63$var$analyticsParams));
    var handleOnBlur = (0, $koa2c.usePlatformLeafEventHandler)($54339ad51eb86f63$var$_objectSpread({
        fn: function fn(event) {
            onBlur && onBlur(event);
        },
        action: "blurred"
    }, $54339ad51eb86f63$var$analyticsParams));
    var handleOnMouseDown = (0, $91i6m.useCallback)(function(event) {
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        var target = event.target;
        if (target.tagName !== "INPUT") event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    var setInputRef = (0, $91i6m.useCallback)(function(inputElement) {
        inputRef.current = inputElement;
        if (!ref) return;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(ref) === "object") ref.current = inputElement;
        if (typeof ref === "function") ref(inputElement);
    }, [
        ref
    ]);
    var containerStyles = (0, $91i6m.useMemo)(function() {
        return (0, $4ucu0.containerStyles)(appearance, width);
    }, [
        appearance,
        width
    ]);
    var inputStyle = (0, $4ucu0.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ (0, $lPOF7.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && "".concat(testId, "-container"),
        onMouseDown: handleOnMouseDown,
        css: containerStyles,
        className: className
    }, elemBeforeInput, (0, $lPOF7.jsx)("input", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, spreadProps, {
        "aria-invalid": isInvalid ? isInvalid : undefined,
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    })), elemAfterInput));
});
var $54339ad51eb86f63$export$2e2bcd8739ae039 = $54339ad51eb86f63$var$Textfield;

});
parcelRegister("4ucu0", function(module, exports) {

$parcel$export(module.exports, "containerStyles", function () { return $3443a59df996b78f$export$5972a68b6e54f38f; });
$parcel$export(module.exports, "inputStyles", function () { return $3443a59df996b78f$export$3eeb47dc8e6249d9; });

var $dsN6L = parcelRequire("dsN6L");

var $kLNLK = parcelRequire("kLNLK");
function $3443a59df996b78f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3443a59df996b78f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3443a59df996b78f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3443a59df996b78f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3443a59df996b78f$var$backgroundColor = {
    standard: "var(--ds-background-input, ".concat((0, $kLNLK.N10), ")"),
    subtle: "transparent",
    none: "transparent"
};
var $3443a59df996b78f$var$backgroundColorFocus = {
    standard: "var(--ds-background-input-pressed, ".concat((0, $kLNLK.N0), ")"),
    subtle: "var(--ds-background-input-pressed, ".concat((0, $kLNLK.N0), ")"),
    none: "transparent"
};
var $3443a59df996b78f$var$backgroundColorHover = {
    standard: "var(--ds-background-input-hovered, ".concat((0, $kLNLK.N30), ")"),
    subtle: "var(--ds-background-input-hovered, ".concat((0, $kLNLK.N30), ")"),
    none: "transparent"
};
var $3443a59df996b78f$var$borderColor = {
    standard: "var(--ds-border-input, ".concat((0, $kLNLK.N100), ")"),
    subtle: "transparent",
    none: "transparent"
};
var $3443a59df996b78f$var$borderColorFocus = {
    standard: "var(--ds-border-focused, ".concat((0, $kLNLK.B200), ")"),
    subtle: "var(--ds-border-focused, ".concat((0, $kLNLK.B200), ")"),
    none: "transparent"
};
var $3443a59df996b78f$var$borderColorHover = {
    standard: "var(--ds-border-input, ".concat((0, $kLNLK.N100), ")"),
    subtle: "var(--ds-border-input, transparent)",
    none: "transparent"
};
var $3443a59df996b78f$var$getContainerTextBgAndBorderColor = function getContainerTextBgAndBorderColor(appearance) {
    return {
        backgroundColor: $3443a59df996b78f$var$backgroundColor[appearance],
        borderColor: $3443a59df996b78f$var$borderColor[appearance],
        color: "var(--ds-text, ".concat((0, $kLNLK.N900), ")"),
        cursor: "text",
        "&:hover:not([data-disabled])": {
            backgroundColor: $3443a59df996b78f$var$backgroundColorHover[appearance],
            borderColor: $3443a59df996b78f$var$borderColorHover[appearance]
        },
        "&:focus-within:not([data-disabled])": {
            backgroundColor: $3443a59df996b78f$var$backgroundColorFocus[appearance],
            borderColor: $3443a59df996b78f$var$borderColorFocus[appearance],
            boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", $3443a59df996b78f$var$borderColorFocus[appearance])
        },
        "&[data-disabled]": $3443a59df996b78f$var$_objectSpread({
            color: "var(--ds-text-disabled, ".concat((0, $kLNLK.N70), ")"),
            cursor: "not-allowed"
        }, appearance === "standard" && {
            backgroundColor: "var(--ds-background-disabled, ".concat((0, $kLNLK.N10), ")"),
            borderColor: "var(--ds-background-disabled, ".concat((0, $kLNLK.N10), ")")
        }),
        "&[data-invalid], &[data-invalid]:hover": {
            borderColor: "var(--ds-border-danger, ".concat((0, $kLNLK.R400), ")"),
            boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", "var(--ds-border-danger, ".concat((0, $kLNLK.R400), ")"))
        },
        "&[data-invalid]:focus-within": {
            backgroundColor: "var(--ds-background-input-pressed, ".concat((0, $kLNLK.N0), ")"),
            borderColor: "var(--ds-border-focused, ".concat((0, $kLNLK.B200), ")"),
            boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", "var(--ds-border-focused, ".concat((0, $kLNLK.B200), ")"))
        },
        "@media screen and (-ms-high-contrast: active)": {
            "&[data-invalid]:focus-within": {
                borderColor: "Highlight"
            },
            "&:focus-within": {
                borderColor: "Highlight"
            },
            "&[data-disabled]": {
                borderColor: "GrayText"
            }
        }
    };
};
var $3443a59df996b78f$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
var $3443a59df996b78f$var$getMaxWidth = function getMaxWidth(width) {
    return !width ? "100%" : width in $3443a59df996b78f$var$widthMap ? $3443a59df996b78f$var$widthMap[width] : +width;
};
var $3443a59df996b78f$export$5972a68b6e54f38f = function containerStyles(appearance, width) {
    return $3443a59df996b78f$var$_objectSpread($3443a59df996b78f$var$_objectSpread($3443a59df996b78f$var$_objectSpread({
        alignItems: "center"
    }, $3443a59df996b78f$var$getContainerTextBgAndBorderColor(appearance)), {}, {
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)"
    }, appearance !== "none" ? {
        padding: "var(--ds-border-width, 1px)".concat(" 0")
    } : {}), {}, {
        borderStyle: appearance === "none" ? "none" : "solid",
        boxSizing: "border-box",
        display: "flex",
        flex: "1 1 100%",
        font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
        justifyContent: "space-between",
        maxWidth: $3443a59df996b78f$var$getMaxWidth(width),
        overflow: "hidden",
        transition: "background-color 0.2s ease-in-out, border-color 0.2s ease-in-out",
        wordWrap: "break-word",
        verticalAlign: "top",
        pointerEvents: "auto"
    });
};
var $3443a59df996b78f$export$3eeb47dc8e6249d9 = function inputStyles() {
    return {
        backgroundColor: "transparent",
        border: 0,
        boxSizing: "border-box",
        color: "inherit",
        cursor: "inherit",
        font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
        minWidth: "0",
        outline: "none",
        width: "100%",
        "&[data-monospaced]": {
            fontFamily: 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)'
        },
        "&[data-compact]": {
            padding: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-075, 6px)")
        },
        "&:not([data-compact])": {
            padding: "var(--ds-space-100, 8px)".concat(" ", "var(--ds-space-075, 6px)")
        },
        "&[disabled]": {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: "var(--ds-text-disabled, ".concat((0, $kLNLK.N70), ")")
        },
        // Hide the clear indicator on Edge (Windows only)
        "&::-ms-clear": {
            display: "none"
        },
        "&:invalid": {
            boxShadow: "none"
        },
        "&:placeholder-shown": {
            textOverflow: "ellipsis"
        },
        "&::placeholder": {
            color: "var(--ds-text-subtlest, ".concat((0, $kLNLK.N200), ")"),
            "&:disabled": {
                color: "var(--ds-text-disabled, ".concat((0, $kLNLK.N70), ")")
            }
        },
        "@media screen and (-ms-high-contrast: active)": {
            "&[disabled]": {
                color: "GrayText"
            }
        }
    };
};

});


parcelRegister("9yEtj", function(module, exports) {

$parcel$export(module.exports, "ErrorMessage", function () { return $6f56aedca101884d$export$915e9e7bd4f0f96d; });
/** @jsx jsx */ 
var $lPOF7 = parcelRequire("lPOF7");

var $6m0jT = parcelRequire("6m0jT");

var $daZRO = parcelRequire("daZRO");

var $kLNLK = parcelRequire("kLNLK");

var $kROoV = parcelRequire("kROoV");
/**
 * API for the internal `<Message />` component. This is not public API.
 */ /**
 * Public API of the various message components.
 */ var $6f56aedca101884d$var$messageStyles = (0, $lPOF7.css)({
    display: "flex",
    justifyContent: "baseline",
    gap: "var(--ds-space-050, 4px)",
    font: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    marginBlockStart: "var(--ds-space-050, 4px)"
});
var $6f56aedca101884d$var$messageAppearanceStyles = {
    default: (0, $lPOF7.css)({
        color: "var(--ds-text-subtlest, ".concat((0, $kLNLK.N200), ")")
    }),
    error: (0, $lPOF7.css)({
        color: "var(--ds-text-danger, #AE2A19)"
    }),
    valid: (0, $lPOF7.css)({
        color: "var(--ds-text-success, #216E4E)"
    })
};
var $6f56aedca101884d$var$iconWrapperStyles = (0, $lPOF7.css)({
    display: "flex"
});
var $6f56aedca101884d$var$IconWrapper = function IconWrapper(_ref) {
    var children = _ref.children;
    return (0, $lPOF7.jsx)("span", {
        css: $6f56aedca101884d$var$iconWrapperStyles
    }, children);
};
var $6f56aedca101884d$var$messageIcons = {
    error: (0, $lPOF7.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($daZRO))), {
        size: "small",
        label: "error"
    }),
    valid: (0, $lPOF7.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6m0jT))), {
        size: "small",
        label: "success"
    })
};
var $6f56aedca101884d$var$Message = function Message(_ref2) {
    var children = _ref2.children, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, fieldId = _ref2.fieldId, testId = _ref2.testId;
    var icon = $6f56aedca101884d$var$messageIcons[appearance];
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ var content = typeof children === "string" ? children : (0, $lPOF7.jsx)("span", null, children);
    return (0, $lPOF7.jsx)("div", {
        css: [
            $6f56aedca101884d$var$messageStyles,
            $6f56aedca101884d$var$messageAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        id: fieldId,
        "aria-live": "polite"
    }, icon && (0, $lPOF7.jsx)($6f56aedca101884d$var$IconWrapper, null, icon), content);
};
var $6f56aedca101884d$export$8fbe3c7d0ed2c683 = function HelperMessage(_ref3) {
    var children = _ref3.children, testId = _ref3.testId;
    return (0, $lPOF7.jsx)((0, $kROoV.FieldId).Consumer, null, function(fieldId) {
        return (0, $lPOF7.jsx)($6f56aedca101884d$var$Message, {
            fieldId: fieldId ? "".concat(fieldId, "-helper") : undefined,
            testId: testId
        }, children);
    });
};
var $6f56aedca101884d$export$915e9e7bd4f0f96d = function ErrorMessage(_ref4) {
    var children = _ref4.children, testId = _ref4.testId;
    return (0, $lPOF7.jsx)((0, $kROoV.FieldId).Consumer, null, function(fieldId) {
        return (0, $lPOF7.jsx)($6f56aedca101884d$var$Message, {
            appearance: "error",
            fieldId: fieldId ? "".concat(fieldId, "-error") : undefined,
            testId: testId
        }, children);
    });
};
var $6f56aedca101884d$export$5505afb209a532c8 = function ValidMessage(_ref5) {
    var children = _ref5.children, testId = _ref5.testId;
    return (0, $lPOF7.jsx)((0, $kROoV.FieldId).Consumer, null, function(fieldId) {
        return (0, $lPOF7.jsx)($6f56aedca101884d$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? "".concat(fieldId, "-valid") : undefined,
            testId: testId
        }, children);
    });
};

});
parcelRegister("6m0jT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a050babc32300d7$var$_react = $4a050babc32300d7$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6crSb = parcelRequire("6crSb");
function $4a050babc32300d7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $4a050babc32300d7$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $4a050babc32300d7$var$_react.default.createElement($6crSb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 20a8 8 0 110-16 8 8 0 010 16zm1.364-10.964l-2.152 4.11-1.543-1.39a1 1 0 10-1.338 1.487l2.5 2.25a1 1 0 001.555-.279l2.75-5.25a1 1 0 00-1.772-.928z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$4a050babc32300d7$var$EditorSuccessIcon.displayName = "EditorSuccessIcon";
var $4a050babc32300d7$var$_default = $4a050babc32300d7$var$EditorSuccessIcon;
module.exports.default = $4a050babc32300d7$var$_default;

});



parcelRegister("8tnYQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42aa2300f6a2cb0c$export$2e2bcd8739ae039; });

var $fqDmW = parcelRequire("fqDmW");

var $kLNLK = parcelRequire("kLNLK");
let $42aa2300f6a2cb0c$var$_ = (t)=>t, $42aa2300f6a2cb0c$var$t;
const $42aa2300f6a2cb0c$var$iconSize = "24px";
var $42aa2300f6a2cb0c$export$2e2bcd8739ae039 = (0, $fqDmW.default).span($42aa2300f6a2cb0c$var$t || ($42aa2300f6a2cb0c$var$t = $42aa2300f6a2cb0c$var$_`
  color: ${0};
  height: ${0};
  width: ${0};

  + div input {
    margin-right: ${0};
  }
`), (0, $kLNLK).N500, $42aa2300f6a2cb0c$var$iconSize, $42aa2300f6a2cb0c$var$iconSize, $42aa2300f6a2cb0c$var$iconSize);

});

parcelRegister("gaHKK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcb38136af8a7975$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $dcb38136af8a7975$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    loginFormUsernamePlaceholder: {
        id: "login.form.username.placeholder",
        defaultMessage: "Enter email"
    },
    loginFormUsernameLabel: {
        id: "login.form.username.label",
        defaultMessage: "Email"
    }
});

});


parcelRegister("9w0eB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b319ab9a4a7a53ac$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $gFwNN = parcelRequire("gFwNN");

var $c1txK = parcelRequire("c1txK");

var $cJRdM = parcelRequire("cJRdM");

var $leG06 = parcelRequire("leG06");

var $0wXBc = parcelRequire("0wXBc");
const $b319ab9a4a7a53ac$var$PasswordContainer = ({ className: className, fieldError: fieldError, isHidden: isHidden, onChange: onChange, value: value })=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const inputRef = (0, $91i6m.useRef)(null);
    const wasHidden = (0, $0wXBc.usePrevious)(isHidden);
    (0, $91i6m.useEffect)(()=>{
        var _inputRef_current;
        if (!isHidden && wasHidden) (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
    }, [
        isHidden,
        wasHidden
    ]);
    const fieldErrorNode = fieldError ? /*#__PURE__*/ (0, $4ZSso.jsx)("span", {
        id: "password-error",
        children: fieldError
    }) : fieldError;
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gFwNN.default), {
        isHidden: isHidden,
        className: className,
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $c1txK.default), {
            id: "password",
            testId: "password" // used in pollinators
            ,
            name: "password",
            autoComplete: "current-password",
            placeholder: formatMessage((0, $cJRdM.default).passwordPlaceholder),
            label: formatMessage((0, $cJRdM.default).passwordLabel),
            autoFocus: !isHidden,
            isLabelHidden: true,
            onChange: onChange,
            isInvalid: !!fieldError,
            invalidMessage: fieldErrorNode,
            value: value,
            ref: inputRef
        })
    });
};
var $b319ab9a4a7a53ac$export$2e2bcd8739ae039 = $b319ab9a4a7a53ac$var$PasswordContainer;

});
parcelRegister("cJRdM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92a8e4c7e4d2e5c9$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $92a8e4c7e4d2e5c9$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    passwordPlaceholder: {
        id: "login.form.password.placeholder",
        defaultMessage: "Enter password"
    },
    passwordLabel: {
        id: "login.form.password.label",
        defaultMessage: "Password"
    }
});

});


parcelRegister("lkawQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eecdbb3e8b3e970b$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $fqDmW = parcelRequire("fqDmW");

var $6e88g = parcelRequire("6e88g");

var $gFwNN = parcelRequire("gFwNN");
let $eecdbb3e8b3e970b$var$_ = (t)=>t, $eecdbb3e8b3e970b$var$t;
const $eecdbb3e8b3e970b$export$fbbb54563138a84f = (0, $fqDmW.default).div($eecdbb3e8b3e970b$var$t || ($eecdbb3e8b3e970b$var$t = $eecdbb3e8b3e970b$var$_`
  box-sizing: border-box;
  height: 39px;
  overflow: hidden;
  padding: 10px 9px;
  text-overflow: ellipsis;
  white-space: nowrap;

  /* Offset FieldGroup negative margin. */
  margin-top: ${0}px;
`), (0, $6e88g.gridSize)());
const $eecdbb3e8b3e970b$var$RestrictedEmailContainer = ({ value: value })=>{
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gFwNN.default), {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)($eecdbb3e8b3e970b$export$fbbb54563138a84f, {
                title: value,
                children: value
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)("input", {
                "data-testid": "restricted-email-container",
                autoComplete: "username",
                type: "hidden",
                name: "username",
                value: value
            })
        ]
    });
};
var $eecdbb3e8b3e970b$export$2e2bcd8739ae039 = $eecdbb3e8b3e970b$var$RestrictedEmailContainer;

});

parcelRegister("31nHY", function(module, exports) {

$parcel$export(module.exports, "FormErrorWrapper", function () { return $807125d1ec365411$export$21ea266f0fa7d7c3; });
$parcel$export(module.exports, "default", function () { return $807125d1ec365411$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "SectionError", function () { return $807125d1ec365411$export$1142f7f46d50535e; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $fqDmW = parcelRequire("fqDmW");

var $6e88g = parcelRequire("6e88g");

var $8iEgn = parcelRequire("8iEgn");
let $807125d1ec365411$var$_ = (t)=>t, $807125d1ec365411$var$t, $807125d1ec365411$var$t1;
const $807125d1ec365411$export$21ea266f0fa7d7c3 = (0, $fqDmW.default).div($807125d1ec365411$var$t || ($807125d1ec365411$var$t = $807125d1ec365411$var$_`
  margin-bottom: ${0}px;
`), (0, $6e88g.gridSize)() * 2);
const $807125d1ec365411$var$SectionErrorWrapper = (0, $fqDmW.default).div($807125d1ec365411$var$t1 || ($807125d1ec365411$var$t1 = $807125d1ec365411$var$_`
  margin-top: ${0}px;
  margin-bottom: ${0}px;
`), (0, $6e88g.gridSize)(), (0, $6e88g.gridSize)());
function $807125d1ec365411$export$2e2bcd8739ae039({ testId: testId, title: title, children: children }) {
    return children ? /*#__PURE__*/ (0, $4ZSso.jsx)($807125d1ec365411$export$21ea266f0fa7d7c3, {
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8iEgn.default), {
            testId: testId || "form-error",
            appearance: "warning",
            title: title,
            children: children
        })
    }) : null;
}
function $807125d1ec365411$export$1142f7f46d50535e({ id: id, testId: testId, title: title, children: children }) {
    return children ? /*#__PURE__*/ (0, $4ZSso.jsx)($807125d1ec365411$var$SectionErrorWrapper, {
        id: id,
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8iEgn.default), {
            testId: testId || "form-error",
            appearance: "warning",
            title: title,
            children: children
        })
    }) : null;
}

});

parcelRegister("lnbpL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c71a1682cc4a680$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $fqDmW = parcelRequire("fqDmW");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");
let $5c71a1682cc4a680$var$_ = (t)=>t, $5c71a1682cc4a680$var$t;
const $5c71a1682cc4a680$var$FormInfo = (0, $fqDmW.default).div($5c71a1682cc4a680$var$t || ($5c71a1682cc4a680$var$t = $5c71a1682cc4a680$var$_`
  color: ${0};
  font-size: 13px;
  line-height: 17px;
  margin-bottom: 24px;
  margin-top: -4px;
  transform: rotateX(0deg);
  transform-origin: 50% 0;
  transition-property: visibility, height, margin-bottom, opacity, transform, padding;
  transition-duration: 0s, 0.2s, 0.2s, 0.2s, 0.2s;
  transition-timing-function: ease-in-out;
  text-align: center;

  &.hidden {
    height: 0;
    margin-bottom: 0;
    opacity: 0;
    padding: 0 ${0}px;
    pointer-events: none;
    transform: rotateX(-90deg);
    visibility: hidden;
  }
`), (0, $kLNLK).N700, (0, $6e88g.gridSize)() * 2);
const $5c71a1682cc4a680$var$FormInfoComponent = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $4ZSso.jsx)($5c71a1682cc4a680$var$FormInfo, {
        role: "alert",
        ...props,
        className: props.isHidden ? "hidden" : "",
        children: children
    });
};
var $5c71a1682cc4a680$export$2e2bcd8739ae039 = $5c71a1682cc4a680$var$FormInfoComponent;

});

parcelRegister("j7UeI", function(module, exports) {

$parcel$export(module.exports, "StyledSocialLoginButton", function () { return $6b71b168e012af76$export$27110045cf7ea8db; });
$parcel$export(module.exports, "default", function () { return $6b71b168e012af76$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");
parcelRequire("91i6m");

var $leG06 = parcelRequire("leG06");

var $fqDmW = parcelRequire("fqDmW");

var $6jyTC = parcelRequire("6jyTC");

var $eECIq = parcelRequire("eECIq");

var $fHCVH = parcelRequire("fHCVH");

var $c9rdI = parcelRequire("c9rdI");

var $ccxRw = parcelRequire("ccxRw");

var $ySUvx = parcelRequire("ySUvx");

var $cLysE = parcelRequire("cLysE");

var $8iEgn = parcelRequire("8iEgn");

var $cOOAJ = parcelRequire("cOOAJ");

var $9MKJ7 = parcelRequire("9MKJ7");

var $6d87w = parcelRequire("6d87w");
let $6b71b168e012af76$var$_ = (t)=>t, $6b71b168e012af76$var$t, $6b71b168e012af76$var$t1, $6b71b168e012af76$var$t2, $6b71b168e012af76$var$t3;
const $6b71b168e012af76$export$969af4902a13348e = ({ handleGoogleLogin: handleGoogleLogin, handleMicrosoftLogin: handleMicrosoftLogin, handleAppleLogin: handleAppleLogin, handleSlackLogin: handleSlackLogin })=>{
    const location = (0, $6d87w.useLocation)();
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const microsoftEnabled = (0, $ccxRw.isMicrosoftAuthEnabled)(location);
    const appleEnabled = (0, $ccxRw.isAppleAuthEnabled)(location);
    const slackEnabled = (0, $ccxRw.isSlackAuthEnabled)(location);
    const googleOutageEnabled = (0, $ccxRw.isGoogleLoginOutageAdvisoryEnabled)();
    const microsoftOutageEnabled = (0, $ccxRw.isMicrosoftLoginOutageAdvisoryEnabled)();
    const appleOutageEnabled = (0, $ccxRw.isAppleLoginOutageAdvisoryEnabled)();
    const slackOutageEnabled = (0, $ccxRw.isSlackLoginOutageAdvisoryEnabled)();
    const isSocialLoginOutage = googleOutageEnabled || microsoftOutageEnabled || appleOutageEnabled || slackOutageEnabled;
    const getAdvisorySectionMessage = ()=>{
        const multipleOutages = [
            googleOutageEnabled,
            microsoftOutageEnabled,
            appleOutageEnabled,
            slackOutageEnabled
        ].filter(Boolean).length > 1;
        const sectionMessageTitle = multipleOutages ? formatMessage((0, $ySUvx.default).someOutageTitle) : getAdvisorySectionMessageTitle();
        const sectionMessageDescription = multipleOutages ? formatMessage((0, $ySUvx.default).someOutageDescription) : getAdvisorySectionMessageDescription();
        return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8iEgn.default), {
            testId: "social-login-outage-section-message",
            title: sectionMessageTitle,
            appearance: "warning",
            children: /*#__PURE__*/ (0, $4ZSso.jsx)("p", {
                children: sectionMessageDescription
            })
        });
    };
    const getAdvisorySectionMessageTitle = ()=>googleOutageEnabled ? formatMessage((0, $ySUvx.default).googleOutageTitle) : microsoftOutageEnabled ? formatMessage((0, $ySUvx.default).microsoftOutageTitle) : appleOutageEnabled ? formatMessage((0, $ySUvx.default).appleOutageTitle) : slackOutageEnabled ? formatMessage((0, $ySUvx.default).slackOutageTitle) : formatMessage((0, $ySUvx.default).someOutageTitle);
    const getAdvisorySectionMessageDescription = ()=>googleOutageEnabled ? formatMessage((0, $ySUvx.default).googleOutageDescription) : microsoftOutageEnabled ? formatMessage((0, $ySUvx.default).microsoftOutageDescription) : appleOutageEnabled ? formatMessage((0, $ySUvx.default).appleOutageDescription) : slackOutageEnabled ? formatMessage((0, $ySUvx.default).slackOutageDescription) : formatMessage((0, $ySUvx.default).someOutageDescription);
    const GoogleButton = ()=>{
        return /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$var$SocialLoginOptionWrapper, {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$var$SocialLoginButton, {
                id: "google-auth-button",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($eECIq))),
                onClick: handleGoogleLogin,
                advisoryEnabled: googleOutageEnabled,
                outageTooltipMessage: formatMessage((0, $ySUvx.default).googleOutageDescription),
                children: "Google"
            })
        });
    };
    const MicrosoftButton = ()=>{
        return microsoftEnabled && /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$var$SocialLoginOptionWrapper, {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$var$SocialLoginButton, {
                id: "microsoft-auth-button",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($fHCVH))),
                onClick: handleMicrosoftLogin,
                advisoryEnabled: microsoftOutageEnabled,
                outageTooltipMessage: formatMessage((0, $ySUvx.default).microsoftOutageDescription),
                children: "Microsoft"
            })
        });
    };
    const AppleButton = ()=>{
        return appleEnabled && /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$var$SocialLoginOptionWrapper, {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$var$SocialLoginButton, {
                id: "apple-auth-button",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($6jyTC))),
                onClick: handleAppleLogin,
                advisoryEnabled: appleOutageEnabled,
                outageTooltipMessage: formatMessage((0, $ySUvx.default).appleOutageDescription),
                children: "Apple"
            })
        });
    };
    const SlackButton = ()=>{
        return slackEnabled && /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$var$SocialLoginOptionWrapper, {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$var$SocialLoginButton, {
                id: "slack-auth-button",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($c9rdI))),
                onClick: handleSlackLogin,
                advisoryEnabled: slackOutageEnabled,
                outageTooltipMessage: formatMessage((0, $ySUvx.default).slackOutageDescription),
                children: "Slack"
            })
        });
    };
    const showButtonsGridLayout = ()=>/*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsxs)($6b71b168e012af76$var$SocialLoginButtonRowGroup, {
                    "data-testid": "social-login-button-row",
                    children: [
                        GoogleButton(),
                        MicrosoftButton()
                    ]
                }),
                /*#__PURE__*/ (0, $4ZSso.jsxs)($6b71b168e012af76$var$SocialLoginButtonRowGroup, {
                    "data-testid": "social-login-button-row",
                    children: [
                        AppleButton(),
                        SlackButton()
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0, $4ZSso.jsxs)($6b71b168e012af76$export$e61ba37bbdbb1966, {
        "data-i18n-or": formatMessage((0, $ySUvx.default).socialAuthOr),
        "data-i18n-continue": formatMessage((0, $ySUvx.default).socialAuthOrContinueWith),
        className: "google-login social-login",
        "data-testid": "social-login-wrapper",
        children: [
            showButtonsGridLayout(),
            isSocialLoginOutage && getAdvisorySectionMessage()
        ]
    });
};
const $6b71b168e012af76$export$e61ba37bbdbb1966 = (0, $fqDmW.default).div($6b71b168e012af76$var$t || ($6b71b168e012af76$var$t = $6b71b168e012af76$var$_`
  margin-top: ${0}px;

  &::before {
    color: ${0};
    content: attr(data-i18n-continue);
    display: block;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: ${0}px;
    font-weight: 600;
    text-align: center;
  }
`), (0, $6e88g.gridSize)() * 3, (0, $kLNLK).N300, (0, $6e88g.gridSize)() * 2);
const $6b71b168e012af76$var$SocialLoginButtonRowGroup = (0, $fqDmW.default).div($6b71b168e012af76$var$t1 || ($6b71b168e012af76$var$t1 = $6b71b168e012af76$var$_`
  &:not(:last-child) {
    margin-bottom: ${0}px;
  }
`), (0, $6e88g.gridSize)() * 2);
const $6b71b168e012af76$var$SocialLoginOptionWrapper = (0, $fqDmW.default).div($6b71b168e012af76$var$t2 || ($6b71b168e012af76$var$t2 = $6b71b168e012af76$var$_`
  &:not(:last-child) {
    margin-bottom: ${0}px;
  }
`), (0, $6e88g.gridSize)() * 2);
const $6b71b168e012af76$var$SocialLoginButton = ({ children: children, logo: logo, advisoryEnabled: advisoryEnabled, outageTooltipMessage: outageTooltipMessage, ...props })=>{
    const commonProps = {
        isFullWidth: true,
        iconBefore: /*#__PURE__*/ (0, $4ZSso.jsx)("img", {
            src: logo,
            alt: ""
        })
    };
    if (advisoryEnabled) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9MKJ7.default), {
        testId: "social-auth-button-tooltip",
        content: outageTooltipMessage,
        children: /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$export$27110045cf7ea8db, {
            advisoryEnabled: true,
            iconAfter: /*#__PURE__*/ (0, $4ZSso.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cOOAJ))), {
                testId: "social-auth-button-warning-icon",
                label: "",
                primaryColor: (0, $kLNLK).Y500,
                secondaryColor: (0, $kLNLK).Y50
            }),
            ...commonProps,
            ...props,
            children: children
        })
    });
    else return /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$export$27110045cf7ea8db, {
        advisoryEnabled: false,
        ...commonProps,
        ...props,
        children: children
    });
};
const $6b71b168e012af76$export$27110045cf7ea8db = (0, $fqDmW.default)((0, $cLysE.default), {
    shouldForwardProp: (propName)=>![
            "advisoryEnabled"
        ].includes(propName)
})($6b71b168e012af76$var$t3 || ($6b71b168e012af76$var$t3 = $6b71b168e012af76$var$_`
  background: ${0} !important;
  box-shadow: none;
  font-weight: bold;
  border: 1px solid ${0};
  border-radius: 3px;
  color: ${0};
  span {
    flex-grow: unset;
  }

  &:not(:last-child) {
    margin-bottom: ${0}px;
  }

  &:hover {
    background: ${0} !important;
  }
  &:active {
    background: ${0} !important;
    color: ${0} !important;
  }
  &:focus {
    box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.2), 0 0 0 2px rgba(38, 132, 255, 0.6) !important;
  }
  img {
    height: 24px;
    width: 24px;
    margin-right: 6px;
  }
`), (props)=>props.advisoryEnabled ? (0, $kLNLK).Y50 : (0, $kLNLK).N0, (0, $kLNLK).N50, (0, $kLNLK).N800, (0, $6e88g.gridSize)() * 0.5, (0, $kLNLK).N10A, (0, $kLNLK).N20A, (0, $kLNLK).N400);
var $6b71b168e012af76$export$2e2bcd8739ae039 = $6b71b168e012af76$export$969af4902a13348e;

});
parcelRegister("6jyTC", function(module, exports) {
module.exports = new URL("apple-logo.54e0d711.svg", import.meta.url).toString();

});

parcelRegister("eECIq", function(module, exports) {
module.exports = new URL("google-logo.5867462c.svg", import.meta.url).toString();

});

parcelRegister("fHCVH", function(module, exports) {
module.exports = new URL("microsoft-logo.c73d8dca.svg", import.meta.url).toString();

});

parcelRegister("c9rdI", function(module, exports) {
module.exports = new URL("slack-logo.5d730c10.svg", import.meta.url).toString();

});

parcelRegister("ySUvx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e74db0f439e21255$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $e74db0f439e21255$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    socialAuthOr: {
        id: "social.auth.or",
        defaultMessage: "or"
    },
    socialAuthOrContinueWith: {
        id: "social.auth.or-continue-with",
        defaultMessage: "Or continue with:"
    },
    socialAuthContinue: {
        id: "social.auth.continue",
        defaultMessage: "Or continue with",
        description: `Precedes third party login buttons. For example, "Or continue with Google"`
    },
    someOutageTitle: {
        id: "some.outage.title",
        defaultMessage: "Issues with some login options",
        description: "Message to the user that there are currently issues logging in with some providers due to an outage"
    },
    googleOutageTitle: {
        id: "google.outage.title",
        defaultMessage: "Issues with Google login",
        description: "Message to the user that there are currently issues logging in with Google due to an outage"
    },
    microsoftOutageTitle: {
        id: "microsoft.outage.title",
        defaultMessage: "Issues with Microsoft login",
        description: "Message to the user that there are currently issues logging in with Microsoft due to an outage"
    },
    appleOutageTitle: {
        id: "apple.outage.title",
        defaultMessage: "Issues with Apple login",
        description: "Message to the user that there are currently issues logging in with Apple due to an outage"
    },
    slackOutageTitle: {
        id: "slack.outage.title",
        defaultMessage: "Issues with Slack login",
        description: "Message to the user that there are currently issues logging in with Slack due to an outage"
    },
    someOutageDescription: {
        id: "some.outage.description",
        defaultMessage: "Some login options are experiencing issues at the moment. You may be able to log in or sign up with your email and password instead.",
        description: "Message to the user that there are currently issues logging in with due to a login provider outage"
    },
    googleOutageDescription: {
        id: "google.outage.description",
        defaultMessage: "There are issues with Google login and signup at the moment. If you are unable to continue with Google, you may be able to use your email and password instead.",
        description: "Message to the user that there are currently issues logging in with Google due to an outage"
    },
    microsoftOutageDescription: {
        id: "microsoft.outage.description",
        defaultMessage: "There are issues with Microsoft login and signup at the moment. If you are unable to continue with Microsoft, you may be able to use your email and password instead.",
        description: "Message to the user that there are currently issues logging in with Microsoft due to an outage"
    },
    appleOutageDescription: {
        id: "apple.outage.description",
        defaultMessage: "There are issues with Apple login and signup at the moment. If you are unable to continue with Apple, you may be able to use your email and password instead.",
        description: "Message to the user that there are currently issues logging in with Apple due to an outage"
    },
    slackOutageDescription: {
        id: "slack.outage.description",
        defaultMessage: "There are issues with Slack login and signup at the moment. If you are unable to continue with Slack, you may be able to use your email and password instead.",
        description: "Message to the user that there are currently issues logging in with Slack due to an outage"
    }
});

});

parcelRegister("cOOAJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $955165eea80d5a75$var$_react = $955165eea80d5a75$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6crSb = parcelRequire("6crSb");
function $955165eea80d5a75$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $955165eea80d5a75$var$WarningIcon = (props)=>/*#__PURE__*/ $955165eea80d5a75$var$_react.default.createElement($6crSb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771L12.938 4.967z" fill="currentColor"/><path d="M12 15a1 1 0 01-1-1V9a1 1 0 012 0v5a1 1 0 01-1 1m0 3a1 1 0 010-2 1 1 0 010 2" fill="inherit"/></g></svg>`
    }, props));
$955165eea80d5a75$var$WarningIcon.displayName = "WarningIcon";
var $955165eea80d5a75$var$_default = $955165eea80d5a75$var$WarningIcon;
module.exports.default = $955165eea80d5a75$var$_default;

});


parcelRegister("jthWj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97147eacdc47bb45$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $97147eacdc47bb45$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    unexpectedErrorHappened: {
        id: "login.form.sso.check.unknown.error",
        defaultMessage: "Unexpected error happened.",
        description: ""
    },
    emailPlaceholder: {
        id: "login.form.email.placeholder",
        defaultMessage: "Enter your email"
    },
    emailEmpty: {
        id: "login.form.email.empty",
        defaultMessage: "Enter an email address"
    },
    passwordEmpty: {
        id: "login.form.password.empty",
        defaultMessage: "Enter your password"
    },
    migrateAccountInfo: {
        id: "login.form.info.migrate.account",
        defaultMessage: "It looks like you already have an Atlassian account with other products such as Jira or Confluence. Log in to finish migrating your {application} account.",
        description: "Login form info container message"
    },
    existingUserSignupAttemptInfo: {
        id: "login.form.info.existing.user.signup.attempt",
        defaultMessage: "It looks like you've already got an account associated with this email. Log in instead or reset your password if you've forgotten it",
        description: "Login form info container message for existing user signup attempt"
    },
    rateLimitErrorMessage: {
        id: "login.form.email.rate-limit-exceeded.error",
        defaultMessage: "There have been too many attempts to reverify your account in the past hour. Please try again later.",
        description: "Telling the user that they have exceeded welcome email limit"
    }
});

});


parcelRegister("gKURT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4108e007ab21b5b$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $fqDmW = parcelRequire("fqDmW");

var $6e88g = parcelRequire("6e88g");

var $kLNLK = parcelRequire("kLNLK");

var $cLysE = parcelRequire("cLysE");

var $7cVVr = parcelRequire("7cVVr");

var $eECIq = parcelRequire("eECIq");

var $fHCVH = parcelRequire("fHCVH");

var $6jyTC = parcelRequire("6jyTC");

var $c9rdI = parcelRequire("c9rdI");

var $gtKO2 = parcelRequire("gtKO2");
let $c4108e007ab21b5b$var$_ = (t)=>t, $c4108e007ab21b5b$var$t, $c4108e007ab21b5b$var$t1, $c4108e007ab21b5b$var$t2, $c4108e007ab21b5b$var$t3;
const $c4108e007ab21b5b$var$SocialLoginBlock = (0, $fqDmW.default).div($c4108e007ab21b5b$var$t || ($c4108e007ab21b5b$var$t = $c4108e007ab21b5b$var$_`
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${0}px;

  border: 1px solid ${0};
  border-radius: 3px;
`), (0, $6e88g.gridSize)() * 1.5, (0, $kLNLK.N50));
const $c4108e007ab21b5b$var$Header = (0, $fqDmW.default).div($c4108e007ab21b5b$var$t1 || ($c4108e007ab21b5b$var$t1 = $c4108e007ab21b5b$var$_`
  display: flex;
  align-self: center;
  justify-content: center;

  width: 100%;
  padding-bottom: ${0}px;
`), (0, $6e88g.gridSize)() * 1.5);
const $c4108e007ab21b5b$var$Email = (0, $fqDmW.default).div($c4108e007ab21b5b$var$t2 || ($c4108e007ab21b5b$var$t2 = $c4108e007ab21b5b$var$_`
  font-weight: 600;
  font-size: 14px;
  line-height: ${0}px;
  color: ${0};

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`), (0, $6e88g.gridSize)() * 3, (0, $kLNLK.N800));
const $c4108e007ab21b5b$var$Logo = (0, $fqDmW.default).img($c4108e007ab21b5b$var$t3 || ($c4108e007ab21b5b$var$t3 = $c4108e007ab21b5b$var$_`
  height: ${0}px;
  padding-right: ${0}px;
`), (0, $6e88g.gridSize)() * 3, (0, $6e88g.gridSize)());
const $c4108e007ab21b5b$var$getLogo = (highlightedSocialProvider)=>{
    switch(highlightedSocialProvider){
        case (0, $gtKO2.SocialProvider).Google:
            return 0, (/*@__PURE__*/$parcel$interopDefault($eECIq));
        case (0, $gtKO2.SocialProvider).Microsoft:
            return 0, (/*@__PURE__*/$parcel$interopDefault($fHCVH));
        case (0, $gtKO2.SocialProvider).Apple:
            return 0, (/*@__PURE__*/$parcel$interopDefault($6jyTC));
        case (0, $gtKO2.SocialProvider).Slack:
            return 0, (/*@__PURE__*/$parcel$interopDefault($c9rdI));
    }
};
const $c4108e007ab21b5b$var$getSocialLoginHandler = ({ highlightedSocialProvider: highlightedSocialProvider, handleGoogleLogin: handleGoogleLogin, handleMicrosoftLogin: handleMicrosoftLogin, handleAppleLogin: handleAppleLogin, handleSlackLogin: handleSlackLogin })=>{
    switch(highlightedSocialProvider){
        case (0, $gtKO2.SocialProvider).Google:
            return handleGoogleLogin;
        case (0, $gtKO2.SocialProvider).Microsoft:
            return handleMicrosoftLogin;
        case (0, $gtKO2.SocialProvider).Apple:
            return handleAppleLogin;
        case (0, $gtKO2.SocialProvider).Slack:
            return handleSlackLogin;
    }
};
const $c4108e007ab21b5b$var$SocialLoginForm = (props)=>{
    const { highlightedSocialProvider: highlightedSocialProvider, email: email } = props;
    const handleSocialLogin = $c4108e007ab21b5b$var$getSocialLoginHandler(props);
    return /*#__PURE__*/ (0, $4ZSso.jsxs)($c4108e007ab21b5b$var$SocialLoginBlock, {
        "data-testid": "social-login-form",
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsxs)($c4108e007ab21b5b$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)($c4108e007ab21b5b$var$Logo, {
                        src: $c4108e007ab21b5b$var$getLogo(highlightedSocialProvider),
                        alt: `${highlightedSocialProvider} logo`
                    }),
                    email && /*#__PURE__*/ (0, $4ZSso.jsx)($c4108e007ab21b5b$var$Email, {
                        children: email
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                isFullWidth: true,
                id: "social-login-submit",
                appearance: "primary",
                onClick: handleSocialLogin,
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    ...(0, $7cVVr.default).continueWith,
                    values: {
                        socialProviderName: highlightedSocialProvider.replace(/^./, (str)=>str.toUpperCase())
                    }
                })
            })
        ]
    });
};
var $c4108e007ab21b5b$export$2e2bcd8739ae039 = $c4108e007ab21b5b$var$SocialLoginForm;

});
parcelRegister("7cVVr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b70b522f9e02cef9$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $b70b522f9e02cef9$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    continueWith: {
        id: "social.login.form.continue-button",
        defaultMessage: "Continue with {socialProviderName}",
        description: "Button label that is a CTA for users to continue logging in using the selected social provider."
    }
});

});


parcelRegister("gx7I6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb3609afe7f9a073$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $8Bf3D = parcelRequire("8Bf3D");

var $bE8z6 = parcelRequire("bE8z6");

var $g6OTd = parcelRequire("g6OTd");

var $7eeh4 = parcelRequire("7eeh4");

var $1TbRW = parcelRequire("1TbRW");
const $cb3609afe7f9a073$var$Footer = ({ isEmbedded: isEmbedded, oidcContext: oidcContext })=>{
    if (isEmbedded || !oidcContext) return null;
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsxs)("ul", {
                className: "fine-print",
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $bE8z6.PrivacyPolicyLink), {
                            isMobileLink: (0, $7eeh4.isMobileOidc)(oidcContext)
                        })
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8Bf3D.default), {}),
                    /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $bE8z6.UserNoticeLink), {
                            isMobileLink: (0, $7eeh4.isMobileOidc)(oidcContext)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $1TbRW.RecaptchaNoticeContainer), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $g6OTd.RecaptchaNotice), {})
            })
        ]
    });
};
var $cb3609afe7f9a073$export$2e2bcd8739ae039 = $cb3609afe7f9a073$var$Footer;

});
parcelRegister("8Bf3D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8598e8620eefabcf$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $fqDmW = parcelRequire("fqDmW");
let $8598e8620eefabcf$var$_ = (t)=>t, $8598e8620eefabcf$var$t;
const $8598e8620eefabcf$var$SeparatorContainer = (0, $fqDmW.default).p($8598e8620eefabcf$var$t || ($8598e8620eefabcf$var$t = $8598e8620eefabcf$var$_`
  margin: 0px 8px;
`));
const $8598e8620eefabcf$var$Bull = ()=>/*#__PURE__*/ (0, $4ZSso.jsx)($8598e8620eefabcf$var$SeparatorContainer, {
        children: "\u2022"
    });
var $8598e8620eefabcf$export$2e2bcd8739ae039 = $8598e8620eefabcf$var$Bull;

});


parcelRegister("4tmE5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dde66b37a92d3c19$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $9b70D = parcelRequire("9b70D");
const $dde66b37a92d3c19$var$Header = ({ highlightedSocialProvider: highlightedSocialProvider, showSocialLoginOnly: showSocialLoginOnly })=>{
    if (showSocialLoginOnly) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
        tagName: "h5",
        ...(0, $9b70D.LoginPageMessages).socialFormTitle,
        values: {
            socialProviderName: highlightedSocialProvider === null || highlightedSocialProvider === void 0 ? void 0 : highlightedSocialProvider.replace(/^./, (str)=>str.toUpperCase())
        }
    });
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
        tagName: "h5",
        ...(0, $9b70D.LoginPageMessages).headTitle
    });
};
var $dde66b37a92d3c19$export$2e2bcd8739ae039 = $dde66b37a92d3c19$var$Header;

});

parcelRegister("k3QGO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $977fc0c59633125c$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $j7UeI = parcelRequire("j7UeI");
const $977fc0c59633125c$var$MaybeSocialLoginPanel = ({ isEmbedded: isEmbedded, isSocialBlocked: isSocialBlocked, envSupportsSocialLogin: envSupportsSocialLogin, onGoogleLogin: onGoogleLogin, onMicrosoftLogin: onMicrosoftLogin, onAppleLogin: onAppleLogin, onSlackLogin: onSlackLogin })=>{
    if (!envSupportsSocialLogin || isEmbedded || isSocialBlocked) return null;
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $j7UeI.default), {
        handleGoogleLogin: onGoogleLogin,
        handleMicrosoftLogin: onMicrosoftLogin,
        handleAppleLogin: onAppleLogin,
        handleSlackLogin: onSlackLogin
    });
};
var $977fc0c59633125c$export$2e2bcd8739ae039 = $977fc0c59633125c$var$MaybeSocialLoginPanel;

});

parcelRegister("68WXR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ef3e311772fd3c0$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $6d87w = parcelRequire("6d87w");

var $dBq8m = parcelRequire("dBq8m");

var $2aGBJ = parcelRequire("2aGBJ");

var $k8MAo = parcelRequire("k8MAo");

var $8Bf3D = parcelRequire("8Bf3D");

var $64QTD = parcelRequire("64QTD");

var $gtKO2 = parcelRequire("gtKO2");

var $7eeh4 = parcelRequire("7eeh4");

var $1V2cH = parcelRequire("1V2cH");

var $bqdjD = parcelRequire("bqdjD");

var $9b70D = parcelRequire("9b70D");

var $1UkGo = parcelRequire("1UkGo");

var $6OnpU = parcelRequire("6OnpU");
const $1ef3e311772fd3c0$var$WhiteboxFooter = ({ isMobileApp: isMobileApp, oidcContext: oidcContext, showSocialLoginOnly: showSocialLoginOnly })=>{
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const isCommercial = (0, $bqdjD.getCurrentPerimeter)() === "commercial";
    const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(location.search);
    const signupLinkEnabled = (0, $91i6m.useMemo)(()=>{
        // Due to Apple Store rules, we don't want sign up link on login page in Mobile OAuth case, unless we provide redirection from login to signup
        const shouldRenderSignupLink = isCommercial && (!isMobileApp || (0, $7eeh4.isOidcDisplayMode)(oidcContext, (0, $gtKO2.OidcDisplay).LoginWithRedirect));
        return queryParams.shide !== "true" && shouldRenderSignupLink;
    }, [
        isCommercial,
        isMobileApp,
        oidcContext,
        queryParams.shide
    ]);
    const getSignupLinkElement = ()=>{
        if (signupLinkEnabled) {
            const elementText = /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                ...(0, $9b70D.LoginPageMessages).createAnAccount
            });
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6d87w.Link), {
                to: "/signup" + location.search,
                id: "signup",
                className: "primary-action",
                onClick: ()=>{
                    analyticsClient.linkClickedEvent((0, $1UkGo.pageId), "signUpLink");
                },
                children: elementText
            });
        }
        return null;
    };
    const signupLink = getSignupLinkElement();
    if (showSocialLoginOnly) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $64QTD.default), {
        id: "use-a-different-login-method",
        spacing: "none",
        onClick: ()=>{
            dispatch((0, $k8MAo.resetLoginForm)());
        },
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            ...(0, $9b70D.LoginPageMessages).socialFormUseDifferentLoginMethod
        })
    });
    return /*#__PURE__*/ (0, $4ZSso.jsxs)("ul", {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6OnpU.ResetPasswordLink), {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                        id: "trouble.logging.in",
                        defaultMessage: "Can't log in?"
                    })
                })
            }),
            signupLink && /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8Bf3D.default), {}),
                    /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                        children: signupLink
                    })
                ]
            })
        ]
    });
};
var $1ef3e311772fd3c0$export$2e2bcd8739ae039 = $1ef3e311772fd3c0$var$WhiteboxFooter;

});

parcelRegister("6KORI", function(module, exports) {

$parcel$export(module.exports, "useGoogleOneTap", function () { return $0514ccbfce379500$export$84fc8ad34c97e462; });

var $91i6m = parcelRequire("91i6m");

var $h6aRF = parcelRequire("h6aRF");

var $fALlm = parcelRequire("fALlm");

var $NAfW5 = parcelRequire("NAfW5");
const $0514ccbfce379500$export$84fc8ad34c97e462 = ({ email: email })=>{
    (0, $h6aRF.useRegisterComponent)($0514ccbfce379500$export$84fc8ad34c97e462.name);
    const { setLoginRecoveryOptions: setLoginRecoveryOptions } = (0, $fALlm.useLoginRecoveryOptionsContext)();
    const buildLoginRecoveryOptions = (0, $NAfW5.useLoginRecoveryOptions)();
    (0, $91i6m.useEffect)(()=>{
        if (!email) return;
        const loginRecoveryOptions = buildLoginRecoveryOptions(email);
        setLoginRecoveryOptions(loginRecoveryOptions);
    }, [
        email,
        setLoginRecoveryOptions,
        buildLoginRecoveryOptions
    ]);
};

});


parcelRegister("15GiP", function(module, exports) {

$parcel$export(module.exports, "fontFallback", function () { return $0cb7128838712e24$export$2a99220fb32ec798; });
$parcel$export(module.exports, "headingSizes", function () { return $0cb7128838712e24$export$bc02e067df412c3b; });
$parcel$export(module.exports, "h900", function () { return $0cb7128838712e24$export$bdb8f897727a9c67; });
$parcel$export(module.exports, "h800", function () { return $0cb7128838712e24$export$3953fb6fbd158d23; });
$parcel$export(module.exports, "h700", function () { return $0cb7128838712e24$export$e4f993a313607daa; });
$parcel$export(module.exports, "h600", function () { return $0cb7128838712e24$export$1e8b2acea3fb3119; });
$parcel$export(module.exports, "h500", function () { return $0cb7128838712e24$export$85aa43a9b9f06707; });
$parcel$export(module.exports, "h400", function () { return $0cb7128838712e24$export$fcb7764b80bd908f; });
$parcel$export(module.exports, "h300", function () { return $0cb7128838712e24$export$a0e59c3bbc05e815; });
$parcel$export(module.exports, "h200", function () { return $0cb7128838712e24$export$7ccf32eb2150ac7e; });
$parcel$export(module.exports, "h100", function () { return $0cb7128838712e24$export$dfc0e69214efdc3c; });

var $dsN6L = parcelRequire("dsN6L");

var $kLNLK = parcelRequire("kLNLK");

var $6e88g = parcelRequire("6e88g");
function $0cb7128838712e24$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0cb7128838712e24$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0cb7128838712e24$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0cb7128838712e24$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0cb7128838712e24$export$2a99220fb32ec798 = {
    heading: {
        xxlarge: 'normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xlarge: 'normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        large: 'normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xsmall: 'normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xxsmall: 'normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    },
    body: {
        large: 'normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        UNSAFE_small: 'normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    }
};
var $0cb7128838712e24$var$baseHeading = function baseHeading(size, lineHeight) {
    return {
        fontSize: "".concat(size / 14, "em"),
        fontStyle: "inherit",
        lineHeight: lineHeight / size
    };
};
var $0cb7128838712e24$export$bc02e067df412c3b = {
    h900: {
        size: 35,
        lineHeight: 40
    },
    h800: {
        size: 29,
        lineHeight: 32
    },
    h700: {
        size: 24,
        lineHeight: 28
    },
    h600: {
        size: 20,
        lineHeight: 24
    },
    h500: {
        size: 16,
        lineHeight: 20
    },
    h400: {
        size: 14,
        lineHeight: 16
    },
    h300: {
        size: 12,
        lineHeight: 16
    },
    h200: {
        size: 12,
        lineHeight: 16
    },
    h100: {
        size: 11,
        lineHeight: 16
    }
};
var $0cb7128838712e24$export$bdb8f897727a9c67 = function h900() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h900.size, $0cb7128838712e24$export$bc02e067df412c3b.h900.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $6e88g.gridSize)() * 6.5, "px")
    });
};
var $0cb7128838712e24$export$3953fb6fbd158d23 = function h800() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h800.size, $0cb7128838712e24$export$bc02e067df412c3b.h800.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $6e88g.gridSize)() * 5, "px")
    });
};
var $0cb7128838712e24$export$e4f993a313607daa = function h700() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h700.size, $0cb7128838712e24$export$bc02e067df412c3b.h700.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $6e88g.gridSize)() * 5, "px")
    });
};
var $0cb7128838712e24$export$1e8b2acea3fb3119 = function h600() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h600.size, $0cb7128838712e24$export$bc02e067df412c3b.h600.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.008em",
        marginTop: "".concat((0, $6e88g.gridSize)() * 3.5, "px")
    });
};
var $0cb7128838712e24$export$85aa43a9b9f06707 = function h500() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h500.size, $0cb7128838712e24$export$bc02e067df412c3b.h500.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.006em",
        marginTop: "".concat((0, $6e88g.gridSize)() * 3, "px")
    });
};
var $0cb7128838712e24$export$fcb7764b80bd908f = function h400() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h400.size, $0cb7128838712e24$export$bc02e067df412c3b.h400.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.003em",
        marginTop: "".concat((0, $6e88g.gridSize)() * 2, "px")
    });
};
var $0cb7128838712e24$export$a0e59c3bbc05e815 = function h300() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h300.size, $0cb7128838712e24$export$bc02e067df412c3b.h300.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $6e88g.gridSize)() * 2.5, "px"),
        textTransform: "uppercase"
    });
};
var $0cb7128838712e24$export$7ccf32eb2150ac7e = function h200() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h200.size, $0cb7128838712e24$export$bc02e067df412c3b.h200.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $kLNLK.subtleHeading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $6e88g.gridSize)() * 2, "px")
    });
};
var $0cb7128838712e24$export$dfc0e69214efdc3c = function h100() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h100.size, $0cb7128838712e24$export$bc02e067df412c3b.h100.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $kLNLK.subtleHeading)(props), ")"),
        fontWeight: "var(--ds-font-weight-bold, 700)",
        marginTop: "".concat((0, $6e88g.gridSize)() * 2, "px")
    });
};

});

parcelRegister("jrqUM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2756aa7541c02f4$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $91i6m = parcelRequire("91i6m");

var $lPOF7 = parcelRequire("lPOF7");

var $24QNd = parcelRequire("24QNd");

var $7re4P = parcelRequire("7re4P");

var $3W7HL = parcelRequire("3W7HL");
var $e2756aa7541c02f4$var$asAllowlist = [
    "span",
    "p",
    "strong",
    "em"
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $e2756aa7541c02f4$var$resetStyles = (0, $lPOF7.css)({
    margin: 0,
    overflowWrap: "anywhere"
});
var $e2756aa7541c02f4$var$strongStyles = (0, $lPOF7.css)({
    fontWeight: "bold"
});
var $e2756aa7541c02f4$var$emStyles = (0, $lPOF7.css)({
    fontStyle: "italic"
});
var $e2756aa7541c02f4$var$textAlignMap = {
    center: (0, $lPOF7.css)({
        textAlign: "center"
    }),
    end: (0, $lPOF7.css)({
        textAlign: "end"
    }),
    start: (0, $lPOF7.css)({
        textAlign: "start"
    })
};
var $e2756aa7541c02f4$var$truncationStyles = (0, $lPOF7.css)({
    display: "-webkit-box",
    overflow: "hidden",
    WebkitBoxOrient: "vertical"
});
var $e2756aa7541c02f4$var$wordBreakMap = {
    breakAll: (0, $lPOF7.css)({
        wordBreak: "break-all"
    })
};
var $e2756aa7541c02f4$var$HasTextAncestorContext = /*#__PURE__*/ (0, $91i6m.createContext)(false);
var $e2756aa7541c02f4$var$useHasTextAncestor = function useHasTextAncestor() {
    return (0, $91i6m.useContext)($e2756aa7541c02f4$var$HasTextAncestorContext);
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $e2756aa7541c02f4$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $3W7HL.useSurface)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $7re4P.inverseColorMap).hasOwnProperty(surface)) return (0, $7re4P.inverseColorMap)[surface];
    if (colorProp === "inherit") return undefined;
    if (!colorProp && hasTextAncestor) return undefined;
    return colorProp || "color.text";
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $e2756aa7541c02f4$var$Text = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "span" : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, _ref$size = _ref.size, size = _ref$size === void 0 ? "medium" : _ref$size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $24QNd.default)($e2756aa7541c02f4$var$asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    var hasTextAncestor = $e2756aa7541c02f4$var$useHasTextAncestor();
    var color = $e2756aa7541c02f4$var$useColor(colorProp, hasTextAncestor);
    var component = (0, $lPOF7.jsx)(Component, {
        ref: ref,
        css: [
            $e2756aa7541c02f4$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7re4P.fontStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $7re4P.textColorStylesMap)[color],
            maxLines && $e2756aa7541c02f4$var$truncationStyles,
            maxLines === 1 && $e2756aa7541c02f4$var$wordBreakMap.breakAll,
            align && $e2756aa7541c02f4$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $7re4P.fontWeightStylesMap)[weight],
            Component === "em" && $e2756aa7541c02f4$var$emStyles,
            Component === "strong" && $e2756aa7541c02f4$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $lPOF7.jsx)($e2756aa7541c02f4$var$HasTextAncestorContext.Provider, {
        value: true
    }, component);
});
var $e2756aa7541c02f4$export$2e2bcd8739ae039 = $e2756aa7541c02f4$var$Text;

});
parcelRegister("24QNd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1834e80975c961d7$export$2e2bcd8739ae039; });
var $1834e80975c961d7$var$isProduction = true;
var $1834e80975c961d7$var$prefix = "Invariant failed";
function $1834e80975c961d7$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($1834e80975c961d7$var$isProduction) throw new Error($1834e80975c961d7$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($1834e80975c961d7$var$prefix, ": ").concat(provided) : $1834e80975c961d7$var$prefix;
    throw new Error(value);
}

});


parcelRegister("1a5r2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d8af0efc0b94215$var$_react = $0d8af0efc0b94215$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6crSb = parcelRequire("6crSb");
function $0d8af0efc0b94215$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $0d8af0efc0b94215$var$InfoIcon = (props)=>/*#__PURE__*/ $0d8af0efc0b94215$var$_react.default.createElement($6crSb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12z" fill="currentColor"/><rect fill="inherit" x="11" y="10" width="2" height="7" rx="1"/><circle fill="inherit" cx="12" cy="8" r="1"/></g></svg>`
    }, props));
$0d8af0efc0b94215$var$InfoIcon.displayName = "InfoIcon";
var $0d8af0efc0b94215$var$_default = $0d8af0efc0b94215$var$InfoIcon;
module.exports.default = $0d8af0efc0b94215$var$_default;

});

parcelRegister("lyJnu", function(module, exports) {

$parcel$export(module.exports, "KEY_UP", function () { return $fb1ff9104554a579$export$390330c10ff2b9a1; });
$parcel$export(module.exports, "KEY_DOWN", function () { return $fb1ff9104554a579$export$a80636c6f41931fe; });
$parcel$export(module.exports, "KEY_HOME", function () { return $fb1ff9104554a579$export$4af703091671bc; });
$parcel$export(module.exports, "KEY_END", function () { return $fb1ff9104554a579$export$e2bc30913faa5db7; });
$parcel$export(module.exports, "KEY_TAB", function () { return $fb1ff9104554a579$export$10f6869ed0a7d75b; });
$parcel$export(module.exports, "KEY_ENTER", function () { return $fb1ff9104554a579$export$8152f929a25a0ff4; });
$parcel$export(module.exports, "KEY_SPACE", function () { return $fb1ff9104554a579$export$e51a3576c045c8d5; });
$parcel$export(module.exports, "ESCAPE", function () { return $fb1ff9104554a579$export$2bb790b9008907b4; });
/**
 * Character key codes which can be used in keyboard events.
 */ var $fb1ff9104554a579$export$390330c10ff2b9a1 = "ArrowUp";
var $fb1ff9104554a579$export$a80636c6f41931fe = "ArrowDown";
var $fb1ff9104554a579$export$4af703091671bc = "Home";
var $fb1ff9104554a579$export$e2bc30913faa5db7 = "End";
var $fb1ff9104554a579$export$10f6869ed0a7d75b = "Tab";
var $fb1ff9104554a579$export$8152f929a25a0ff4 = "Enter";
var $fb1ff9104554a579$export$e51a3576c045c8d5 = "Space";
var $fb1ff9104554a579$export$2bb790b9008907b4 = "Escape";

});

parcelRegister("aTAfv", function(module, exports) {

$parcel$export(module.exports, "useUID", function () { return $7eeb28c052954e83$export$87d05f07e65211f1; });
$parcel$export(module.exports, "useUIDSeed", function () { return $7eeb28c052954e83$export$bb5ca5fba6fb4f1f; });

var $91i6m = parcelRequire("91i6m");

var $kV8TC = parcelRequire("kV8TC");
var $7eeb28c052954e83$var$generateUID = function(context) {
    var quartz = context || (0, $kV8TC.counter);
    var prefix = (0, $kV8TC.getPrefix)(quartz);
    var id = (0, $kV8TC.getId)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $7eeb28c052954e83$var$useUIDState = function() {
    var context = (0, $91i6m.useContext)((0, $kV8TC.source));
    var uid = (0, $91i6m.useState)(function() {
        return $7eeb28c052954e83$var$generateUID(context);
    })[0];
    return uid;
};
var $7eeb28c052954e83$export$87d05f07e65211f1 = function() {
    var uid = $7eeb28c052954e83$var$useUIDState().uid;
    return uid;
};
var $7eeb28c052954e83$export$bb5ca5fba6fb4f1f = function() {
    var gen = $7eeb28c052954e83$var$useUIDState().gen;
    return gen;
};

});
parcelRegister("kV8TC", function(module, exports) {

$parcel$export(module.exports, "counter", function () { return $f3b0081445314065$export$e575061ef2a070eb; });
$parcel$export(module.exports, "source", function () { return $f3b0081445314065$export$b4d5da5f34fb77ad; });
$parcel$export(module.exports, "getId", function () { return $f3b0081445314065$export$218c8c3169c024d2; });
$parcel$export(module.exports, "getPrefix", function () { return $f3b0081445314065$export$36e24695f02d4503; });

var $91i6m = parcelRequire("91i6m");

var $3Bnk9 = parcelRequire("3Bnk9");
var $f3b0081445314065$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = "";
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $3Bnk9.generateUID)()
    };
};
var $f3b0081445314065$export$e575061ef2a070eb = $f3b0081445314065$export$1921362e86c73c88();
var $f3b0081445314065$export$b4d5da5f34fb77ad = $91i6m.createContext($f3b0081445314065$export$1921362e86c73c88());
var $f3b0081445314065$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $f3b0081445314065$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : "";
};

});



//# sourceMappingURL=BasePage.891b157c.js.map
